<template>
    <f7-page hide-toolbar-on-scroll :params="f7params">

        <f7-navbar color="pink" large title-large="Large Title">
            <f7-nav-left>    
                <f7-link href="/"><img src="static/icons/logotype.png" width="40" /></f7-link>
            </f7-nav-left>
            <f7-nav-title>TO Defina</f7-nav-title>
            <f7-nav-right>
                <f7-link panel-open="right" class="myclass" href="/setting/">
                    <IconCog />
                </f7-link>
            </f7-nav-right>
        </f7-navbar>



        <f7-toolbar tabbar labels bottom-md>
            <f7-link tab-link="#tab-1" tab-link-active>
                <IconHome />
            </f7-link>
            <f7-link tab-link="#tab-2">
                <IconPlusBoxOutline />
            </f7-link>
            <f7-link tab-link="#tab-3">
                <IconCalendar />
            </f7-link>
            <f7-link tab-link="#tab-4">
                <f7-icon class="icon-fill">
                    <f7-badge color="pink">5</f7-badge>
                    <IconMessageTextOutline /> 
                </f7-icon>
            </f7-link>
        </f7-toolbar>

        <f7-tabs swipeable>
          <f7-tab id="tab-1" class="page-content" tab-active>
            <f7-page>

                <f7-block-title v-if="!isEdit">Task list</f7-block-title>
                <f7-block-title v-else>Edit task</f7-block-title>

                <f7-list v-if="!isEdit">
                    <f7-list-item v-for="task in manager" :key="task.id" :title="task.name" :after="task.category" v-bind:link="task | toUrl"></f7-list-item>
                </f7-list>
                <f7-list v-else>
                    <f7-list-item swipeout v-for="task in manager" :key="task.id" :title="task.name">
                        <f7-swipeout-actions right>
                            <f7-swipeout-button v-bind:href="task | toUrl">
                                <IconPencilOutline />
                            </f7-swipeout-button>
                            <f7-swipeout-button delete>
                                <IconTrashCan />
                            </f7-swipeout-button>
                        </f7-swipeout-actions>
                    </f7-list-item>
                </f7-list>

            </f7-page>
          </f7-tab>
          <f7-tab id="tab-3" class="page-content">
            <f7-block>
                <f7-block-title>Calendar</f7-block-title>
                <div class="block block-strong no-padding">
                  <div id="demo-calendar-inline-container"></div>
                </div>
            </f7-block>
          </f7-tab>
          <f7-tab id="tab-4" class="page-content">
            <f7-page>

                <f7-block-title>My team</f7-block-title>
                <f7-list media-list>
                  <f7-list-item
                    link="#"
                    title="Michael Jackson"
                    subtitle="Accistent">
                    <img slot="media" src="https://cdn.framework7.io/placeholder/fashion-88x88-1.jpg" width="44" />
                  </f7-list-item>
                  <f7-list-item
                    link="#"
                    title="Michel Doille"
                    subtitle="Designer">
                    <img slot="media" src="https://cdn.framework7.io/placeholder/fashion-88x88-6.jpg" width="44" />
                  </f7-list-item>
                  <f7-list-item
                    link="#"
                    title="Billie Jean"
                    subtitle="Programmer">
                    <img slot="media" src="https://cdn.framework7.io/placeholder/fashion-88x88-3.jpg" width="44" />
                  </f7-list-item>
                </f7-list>

            </f7-page>
          </f7-tab>
        </f7-tabs>




    </f7-page>
</template>

<script>
    import Service from '../service'
    import IconHome from 'vue-material-design-icons/Home.vue'
    import IconCalendar from 'vue-material-design-icons/Calendar.vue'
    import IconTrashCan from 'vue-material-design-icons/TrashCan.vue'
    import IconMessageTextOutline from 'vue-material-design-icons/MessageTextOutline.vue'
    import IconPlusBoxOutline from 'vue-material-design-icons/PlusBoxOutline.vue'
    import IconPencilOutline from 'vue-material-design-icons/PencilOutline.vue'
    import IconCog from 'vue-material-design-icons/Cog.vue'

    import Framework7 from 'framework7'
    import Calendar from 'framework7/dist/components/calendar/calendar.js'

    Framework7.use(Calendar)


    export default {
        props: {
            isSelect: Boolean
        },
        components: {
            IconHome, 
            IconCalendar, 
            IconTrashCan, 
            IconPencilOutline, 
            IconCog, 
            IconMessageTextOutline,
            IconPlusBoxOutline
        },
        on: {
          pageInit(e) {
            const self = this;
            const app = self.$f7;
            const $ = self.$$;
            self.calendarDefault = app.calendar.create({
              inputEl: '#demo-calendar-default',
            });
            self.calendarDateFormat = app.calendar.create({
              inputEl: '#demo-calendar-date-format',
              dateFormat: 'DD, MM dd, yyyy',
            });
            self.calendarMultiple = app.calendar.create({
              inputEl: '#demo-calendar-multiple',
              dateFormat: 'M dd yyyy',
              multiple: true,
            });
            self.calendarRange = app.calendar.create({
              inputEl: '#demo-calendar-range',
              dateFormat: 'M dd yyyy',
              rangePicker: true,
            });
            self.calendarModal = app.calendar.create({
              inputEl: '#demo-calendar-modal',
              openIn: 'customModal',
              header: true,
              footer: true,
              dateFormat: 'MM dd yyyy',
            });
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            self.calendarInline = app.calendar.create({
              containerEl: '#demo-calendar-inline-container',
              value: [new Date()],
              renderToolbar() {
                return `${'<div class="toolbar calendar-custom-toolbar no-shadow">' +
            '<div class="toolbar-inner">' +
              '<div class="left">' +
                '<a href="#" class="link icon-only"><i class="icon icon-back '}${self.$theme.md ? 'color-white' : 'color-black'}"></i></a>` +
              '</div>' +
              '<div class="center"></div>' +
              '<div class="right">' +
                `<a href="#" class="link icon-only"><i class="icon icon-forward ${self.$theme.md ? 'color-white' : 'color-black'}"></i></a>` +
              '</div>' +
            '</div>' +
          '</div>';
              },
              on: {
                init(c) {
                  $('.calendar-custom-toolbar .center').text(`${monthNames[c.currentMonth]}, ${c.currentYear}`);
                  $('.calendar-custom-toolbar .left .link').on('click', () => {
                    self.calendarInline.prevMonth();
                  });
                  $('.calendar-custom-toolbar .right .link').on('click', () => {
                    self.calendarInline.nextMonth();
                  });
                },
                monthYearChangeStart(c) {
                  $('.calendar-custom-toolbar .center').text(`${monthNames[c.currentMonth]}, ${c.currentYear}`);
                },
              },
            });
          },
          pageBeforeRemove() {
            const self = this;
            self.calendarDefault.destroy();
            self.calendarDateFormat.destroy();
            self.calendarMultiple.destroy();
            self.calendarRange.destroy();
            self.calendarModal.destroy();
            self.calendarInline.destroy();
          },
        },
        data() {
            return {
                isEdit: false,
                f7params: {
                    id: 'com.myapp.test',
                },
                manager: Service.getMenu(),
            };
        },
        methods: {
            more() {
              this.filters;
            },
            toUrl() {
                return `/task/${task.id}/`;
            }
        },
        filters: {
            toUrl(task) {
                return `/task/${task.id}/`;
            },
        },
    };
</script>

<style>
    .md .toolbar {
        background: #fff;
        color: #000;
    }
    .md .tabbar a.tab-link.tab-link-active, .md .tabbar-labels a.tab-link.tab-link-active, .md .tabbar a.tab-link.active-state, .md .tabbar-labels a.tab-link.active-state {
        color: #e91e63;
    }
    .md .tabbar a.tab-link, .md .tabbar-labels a.tab-link {
        -webkit-transition-duration: 300ms;
        transition-duration: 300ms;
        overflow: hidden;
        color: #111;
        position: relative;
    }
    .material-design-icon > .material-design-icon__svg {
        height: 3em;
        width: 2em;
        fill: currentColor;
        position: absolute;
        bottom: -1em;
        left: -7px;
    }
    .material-design-icon {
        height: 2em;
        width: 2em;
    }
    a.myclass span.material-design-icon > .material-design-icon__svg {
        height: 1em;
        width: 1em;
        left: 18px;
        top: 9px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/home.vue